import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import 'client/styles/bottomBar.scss';

const propTypes = {
  children: PropTypes.element.isRequired,
  barContent: PropTypes.element.isRequired,
  className: PropTypes.string,
  bottomBarClassName: PropTypes.string,
};
const defaultProps = {
  className: null,
  bottomBarClassName: null,
};

// iframe allows for listening to height change of container w/o polling

export default class BottomBarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { fixed: false };
  }

  componentDidMount() {
    this.setPosition();
    window.addEventListener('scroll', this.setPosition);
    this.iframe.contentWindow.addEventListener('resize', this.setPosition);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setPosition);
    this.iframe.contentWindow.removeEventListener('resize', this.setPosition);
  }

  setPosition = () => {
    requestAnimationFrame(this.setFixed);
  }

  setFixed = () => {
    if (this.el) {
      const bottomScroll = window.scrollY + window.innerHeight;
      const bottomEdge = this.el.offsetTop + this.el.clientHeight;
      const fixed = bottomEdge > bottomScroll;

      if (fixed !== this.state.fixed) {
        this.setState({ fixed });
      }
    }
  }

  render() {
    const { children, barContent, className, bottomBarClassName } = this.props;
    return (
      <div
        className={cx('bottom-bar-container', className)}
        ref={(el) => { this.el = el; }}>
        {children}
        <div className={cx('bottom-bar', { fixed: this.state.fixed }, bottomBarClassName)}>
          {barContent}
        </div>
        <iframe tabIndex="0" ref={(el) => { this.iframe = el; }} />
      </div>
    );
  }
}

BottomBarContainer.propTypes = propTypes;
BottomBarContainer.defaultProps = defaultProps;
